enum ErrorReason {
  CarNotFound = 'carNotFound',
  NoAvailableStores = 'noAvailableStores',
}

export default ErrorReason;
